import Wordmark from '../common/Wordmark';

const LoadingScreen = ({ fadingOut = false }) => {
  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center px-6 relative overflow-hidden"
      style={{
        background: `
          radial-gradient(ellipse at 20% 50%, var(--gradient-warm-1) 0%, transparent 50%),
          radial-gradient(ellipse at 80% 20%, var(--gradient-warm-2) 0%, transparent 40%),
          radial-gradient(ellipse at 50% 80%, var(--gradient-warm-3) 0%, transparent 45%),
          radial-gradient(ellipse at 70% 60%, var(--gradient-warm-4) 0%, transparent 50%),
          var(--gradient-base)
        `,
        opacity: fadingOut ? 0 : 1,
        transition: fadingOut ? 'opacity 0.4s ease-in' : undefined,
      }}
    >
      <div className="flex flex-col items-center">

        {/* Logo */}
        <div className="relative w-44 h-44 mb-6 flex items-center justify-center">
          <img
            src="/brand/mark-ring.svg"
            alt=""
            className="relative w-44 h-44"
            style={{ animation: 'logoBloom 0.75s ease-out both' }}
          />
        </div>

        {/* Brand name */}
        <h1
          className="text-4xl text-white mb-2"
          style={{ animation: 'splashEntrance 0.5s ease-out 0.38s both' }}
        >
          <Wordmark />
        </h1>

        {/* Accent divider */}
        <div
          className="w-12 h-0.5 mx-auto mb-3 rounded-full"
          style={{
            background: 'linear-gradient(90deg, transparent, var(--brand-accent), transparent)',
            animation: 'splashEntrance 0.5s ease-out 0.5s both',
          }}
        />

        {/* Tagline */}
        <p
          className="text-sm mb-10 text-center"
          style={{
            color: 'rgba(255,255,255,0.7)',
            animation: 'splashEntrance 0.5s ease-out 0.58s both',
          }}
        >
          A community built for Direct Support Professionals
        </p>

        {/* Brew dots */}
        <div
          className="flex gap-2.5 items-center"
          style={{ animation: 'splashEntrance 0.4s ease-out 0.72s both' }}
        >
          {[0, 1, 2].map(i => (
            <div
              key={i}
              className="w-2 h-2 rounded-full"
              style={{
                backgroundColor: 'var(--brand-accent)',
                animation: `brewDot 1.5s ease-in-out ${i * 0.24}s infinite`,
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
